import type { SVGProps } from 'react';
const SvgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M1.778 1.394A1.65 1.65 0 0 0 .465 2.832c-.024.192-.023 10.008 0 10.22.031.279.136.566.29.792.089.132.314.364.437.452.226.161.46.256.772.313.169.03.28.03 5.462.031 5.74 0 5.406.005 5.67-.085a1.68 1.68 0 0 0 1.071-1.163c.059-.223 1.319-5.381 1.345-5.504a1.664 1.664 0 0 0-1.644-2h-.124v-.5c0-.58-.018-.823-.073-1.013a1.66 1.66 0 0 0-1.347-1.183c-.133-.02-.577-.023-2.998-.024H6.484l-.008-.22a1.53 1.53 0 0 0-.483-1.1 1.6 1.6 0 0 0-.645-.405c-.237-.081-.265-.083-1.898-.081-1.45 0-1.529.002-1.672.032m.243 1.499a.2.2 0 0 0-.052.072c-.012.032-.017 1.572-.017 4.989 0 4.116.004 4.952.022 4.995.025.062.122.15.18.165.109.028.23-.017.3-.11.02-.028.252-.95.747-2.982.394-1.618.738-3.001.765-3.074a1.68 1.68 0 0 1 1.026-.977c.265-.086.113-.083 3.819-.083h3.43l-.004-.548c-.005-.497-.008-.553-.034-.593a.2.2 0 0 0-.069-.06c-.025-.009-1.255-.015-3.268-.015-2.848 0-3.238-.002-3.321-.024a.76.76 0 0 1-.552-.609 8 8 0 0 1-.017-.596v-.485L4.93 2.91l-.046-.047H3.469c-1.314.001-1.415.003-1.448.029m3.394 4.536c-.04.035-.088.22-.729 2.852A475 475 0 0 0 4 13.116c0 .016.87.02 4.297.02 4.698 0 4.366.007 4.404-.09.01-.025.317-1.276.684-2.78l.668-2.734-.028-.052a.2.2 0 0 0-.067-.07c-.029-.013-1.187-.018-4.27-.018h-4.23z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFile;
